import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getIcon } from '../../util/icons';

import { withRouter, NavLink } from 'react-router-dom';

import { MessageModal } from '../modals';

import { isProduction } from '../../util';

class EmployeeSidebarNav extends Component {

  state = {
    modalMessage: null,
    hoveringNonImperativesPage: false,
  }

  showNoSurveyDataModal(){
    this.setState({
      modalMessage: 'The uncover your strengths survey is coming soon to the new app'
    });
  }

  hideModal(){
    this.setState({
      modalMessage: null
    });
  }

  renderMessageModal(){
    return <MessageModal message={this.state.modalMessage} hide={this.hideModal.bind(this)} visible={this.state.modalMessage} />
  }

  render(){

    console.log('rendering employee sidebar nav...');
    console.log('sidebarnav loaded with route params: ', this.props.route);

    const { route, deals } = this.props;

    const name = this.props.user.firstName + ' ' + this.props.user.lastName;
    const organizationId = this.props.user.organizationId;

    const showImperativesMenu = route.indexOf('imperatives') !== -1;
    const { hoveringNonImperativesPage } = this.state;

    const enableDevelopmentPages = !isProduction();

    const surveyTaken = false;

    const activeDeals = _.filter(deals, deal => {
      return deal.status === 'open';
    });

    //TODO might need to implement this for nav link macthing
    //https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/api/NavLink.md
    /*const navLinkIsActive = ( match, location) => {
      return ...
    }*/

    return (
      <div className={`page-sidebar ${hoveringNonImperativesPage ? 'hovering-non-imperative-page ' : ''} ${showImperativesMenu ? 'showing-imperatives ' : ''}`}>

        {this.renderMessageModal()}

        <div className="sidebar-header">
          <h2>{name}</h2>
        </div>
        <ul className="deals">
          <div className="page-name">Seven Imperatives</div>
          <ul className="deals-list">
            <NavLink exact to={`/imperatives`}>
              <li>Deal Summary</li>
            </NavLink>
            {enableDevelopmentPages &&
              <NavLink exact to={`/imperatives-funnel`}>
                <li>Funnel View</li>
              </NavLink>
            }
            <li className="divider"></li>
            {_.map(activeDeals, deal => {
              const { _id, name } = deal;
              return(
                <NavLink
                  key={_id}
                  to={`/imperatives/${_id}`}
                >
                  <li>{name}</li>
                </NavLink>
              )
            })}
          </ul>
        </ul>
        <ul
          className="pages"
          onMouseEnter={() => { this.setState({hoveringNonImperativesPage: true}); }}
          onMouseLeave={() => { this.setState({hoveringNonImperativesPage: false}); }}
          >
          <li
            className="imperatives"
            onMouseEnter={() => { this.setState({hoveringNonImperativesPage: false}); }}
            onMouseLeave={() => { this.setState({hoveringNonImperativesPage: true}); }}
            >
            <NavLink to={`/imperatives`}>
              <div className="page-icon">{getIcon('imperatives')}</div>
              <div className="page-name">Seven Imperatives</div>
            </NavLink>
          </li>
          <li className="section-divider"></li>
          <li>
            <NavLink to="/sprint">
              <div className="page-icon">{getIcon('sprint')}</div>
              <div className="page-name">Velocity Sprint</div>
            </NavLink>
          </li>
          <li>
            <NavLink to={`/plan`}>
              <div className="page-icon">{getIcon('plan')}</div>
              <div className="page-name">Action Plan</div>
            </NavLink>
          </li>
          <li>
            <NavLink to={`/talents`}>
              <div className="page-icon">{getIcon('talents')}</div>
              <div className="page-name">Talent Card</div>
            </NavLink>
          </li>
          <li className="section-divider"></li>
          {!surveyTaken &&
            <li className="disabled">
              <NavLink to="/survey" onClick={(e) => { e.preventDefault(); this.showNoSurveyDataModal(); }}>
                <div className="page-icon">{getIcon('know')}</div>
                <div className="page-name">Uncover Your Strengths</div>
                <div className="disabled-info">{getIcon('info-bold')}</div>
              </NavLink>
            </li>
          }
          {surveyTaken &&
            <li>
              <NavLink to="/know">
                <div className="page-icon">{getIcon('know')}</div>
                <div className="page-name">Know Your Strengths</div>
              </NavLink>
            </li>
          }

          {surveyTaken &&
            <li>
              <NavLink to="/play">
                <div className="page-icon">{getIcon('play')}</div>
                <div className="page-name">Play to Your Strengths</div>
              </NavLink>
            </li>
          }
          {surveyTaken &&
            <li>
              <NavLink to="/improve">
                <div className="page-icon">{getIcon('improve')}</div>
                <div className="page-name">Improve Your Skills</div>
              </NavLink>
            </li>
          }
          {surveyTaken &&
            <li>
              <NavLink to="/showcase">
                <div className="page-icon">{getIcon('showcase')}</div>
                <div className="page-name">Showcase Your Strengths</div>
              </NavLink>
            </li>
          }
          <li className="section-divider"></li>
          {surveyTaken &&
            <li>
              <NavLink to="/responses">
                <div className="page-icon">{getIcon('responses')}</div>
                <div className="page-name">Review Responses</div>
              </NavLink>
            </li>
          }
          <li>
            <NavLink to="/profile">
              <div className="page-icon">{getIcon('profile')}</div>
              <div className="page-name">View / Edit Profile</div>
            </NavLink>
          </li>
        </ul>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps){
  return {
    user: state.user,
    deals: state.deals.data,
    route: ownProps.location.pathname,
  }
}

export default withRouter(connect(mapStateToProps, {})(EmployeeSidebarNav));



// WEBPACK FOOTER //
// ./src/components/shared/employeeSidebarNav.js